<template>
  <div id="center">
    <div class="ulBox">
      <ul>
        <li
          v-for="(item, i) in list"
          :key="item.id"
          :class="i === list.length - 1 ? '' : 'list'"
        >
          <p @click="look(item)" style="cursor: pointer">{{ item.title }}</p>
          <p class="time">{{ item.sendTime }}</p>
        </li>
        <!--      <li class="list">-->
        <!--        <p>-->
        <!--          国家医保局国家卫生健康委关于建立完善国家医保谈判药品“双通道”管理机制的指导意见中文知识网用户指南-->
        <!--        </p>-->
        <!--      </li>-->
        <!--      <li class="list">-->
        <!--        <p>-->
        <!--          国家医保局国家卫生健康委关于建立完善国家医保谈判药品“双通道”管理机制的指导意见中文知识网用户指南-->
        <!--        </p>-->
        <!--      </li>-->
        <!--      <li class="list">-->
        <!--        <p>-->
        <!--          国家医保局国家卫生健康委关于建立完善国家医保谈判药品“双通道”管理机制的指导意见中文知识网用户指南-->
        <!--        </p>-->
        <!--      </li>-->
      </ul>
    </div>
    <Modal
      :scrollable="true"
      v-model="alert"
      width="572px"
      class-name="vertical-center-modal"
      :footer-hide="true"
    >
      <div class="content">
        <div class="title">消息详情</div>
        <div class="neirong">
          <div>{{ details.title }}</div>
          <div>{{ details.sendTime }}</div>
        </div>
        <div class="text">
          {{ details.content }}
        </div>
      </div>
    </Modal>

    <Paging
      :total="total"
      :curPage="page"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
  </div>
</template>

<script>
import Paging from "@/components/paging/index.vue";

export default {
  name: "center",
  components: {
    Paging,
  },
  data() {
    return {
      total: 0,
      alert: false,
      page: 1,
      list: [],
      details: {},
    };
  },
  created() {
    this.dwon();
  },
  methods: {
    async look(item) {
      let res = await this.$apis.userServe.msgDetails({ sysMsgId: item.id });
      console.log(res,'res');
      this.details = res.data;
      this.alert = true;
    },
    async dwon() {
      let obj = {
        pageSize: 10,
        pageNo: this.page,
      };

      let res = await this.$apis.userServe.systemMsg1(obj);
      console.log(res);
      this.total = res.data.total;
      this.list = res.data.list;
      console.log(this.list, "this.list");
    },
    handlePager(i) {
      console.log(i);
      this.page = i;
      this.dwon();
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .title {
    font-weight: 700;
    color: #333;
  }

  .neirong {
    width: 100%;
    margin-top: 20px;
    //background: pink;
    display: flex;
    justify-content: space-between;
  }

  .text {
    height: 300px;
    margin-top: 20px;
    overflow-y: scroll;
  }
}

#center {
  .ulBox {
    padding-top: 30px;
    width: 1200px;
    //height: 1000px;
    min-height: 532px;
    background: #ffffff;
    margin-top: 20px;
    box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  }
  ul {
    margin-left: 44px;
    margin-right: 51px;

    .list {
      border-bottom: 1px #a0a0a0 dotted;
    }

    li {
      width: 100%;
      //background: yellow;
      height: 60px;
      display: flex;
      justify-content: space-between;
      //background: pink;
      .time {
        text-align: right;
      }

      p {
        width: 564px;
        height: 60px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 60px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
</style>
